import React, { memo } from "react";
import PropTypes from 'prop-types';

const SfcCheckBox = memo((props) => {
  return (
    <label className={`${props.name}_${props.value}`}>
      <input
        className={props.className || ''}
        type='checkbox'
        name={props.name}
        value={props.value}
        checked={props.checked}
        onChange={props.onChangeValue}
      />
      {props.label}
    </label>
  );
});

SfcCheckBox.propTypes = {
  name: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onChangeValue: PropTypes.func
};

export default SfcCheckBox;
